import React, { useCallback, useMemo } from 'react';
import { LayoutAdminTable } from 'app/components/templates/LayoutAdminTable';
import { TabsCustom } from 'app/components/elements/TabsCutom';
import { Helmet } from 'react-helmet-async';
import { useInjection } from './hook';
import { TAB } from './type';
import { UpdateTab } from './components/UpdateTab';
import { SeizureReportTab } from './components/SeizureReport';
import { ChatBoxTab } from './components/ChatBoxTab';
import { useNewMessage } from 'contexts/newMessage';

function CommunicationPage() {
  const {
    tab,
    handleChangeTab,
    dates,
    searchParams,
    handleDeleteAllNote,
    handleCopyAllSeizure,
    communicationSeizure,
    handleChangeDate,
    handleDeleteNote,
    onRefreshTabSeizureReport,
    searchText,
    handleSearch,
    updated: {
      dataClientSelected,
      setDataClientSelected,
      handleCopyAllUpdates,
      communicationUpdate
    }
  } = useInjection();
  const { isNewMessage } = useNewMessage();
  const headerTab = useMemo(() => {
    return [
      { label: 'Updates', param: TAB.UPDATES, value: 0 },
      { label: 'Seizure Reports', param: TAB.SEIZURE_REPORTS, value: 1 },
      { label: 'Inbox', param: TAB.CHAT_BOX, value: 2, highlight: isNewMessage }
    ];
  }, [isNewMessage]);

  const renderTab = useCallback(() => {
    const tab = searchParams.get('tab') || TAB.UPDATES;
    if (tab === TAB.UPDATES) {
      return (
        <UpdateTab
          isUpdate
          dataClientSelected={dataClientSelected}
          setDataClientSelected={setDataClientSelected}
          title={'Updates'}
          dateSearch={dates.updates}
          handleChangeDate={handleChangeDate}
          initData={communicationUpdate}
          handleCopyAllUpdates={handleCopyAllUpdates}
          handleDeleteAllNote={(id) => handleDeleteAllNote(id, true)}
        />
      );
    }
    if (tab === TAB.SEIZURE_REPORTS) {
      return (
        <SeizureReportTab
          onRefreshTabSeizureReport={onRefreshTabSeizureReport}
          handleDeleteNote={handleDeleteNote}
          dateSearch={dates.seizureReports}
          handleChangeDate={handleChangeDate}
          initData={communicationSeizure}
          handleCopyAllUpdates={handleCopyAllSeizure}
        />
      );
    }
    if (tab === TAB.CHAT_BOX) {
      return <ChatBoxTab />;
    }
    return <></>;
  }, [
    searchParams,
    dataClientSelected,
    setDataClientSelected,
    handleDeleteNote,
    dates.updates,
    dates.seizureReports,
    handleChangeDate,
    communicationUpdate,
    handleCopyAllUpdates,
    handleDeleteAllNote,
    onRefreshTabSeizureReport,
    communicationSeizure,
    handleCopyAllSeizure
  ]);

  return (
    <LayoutAdminTable title={'Communication'} onSearch={handleSearch} search={searchText}>
      <Helmet>
        <title>Surrey Bailiffs - Communication</title>
      </Helmet>
      <TabsCustom
        tab={tab}
        contentTab={renderTab()}
        headerTab={headerTab}
        onChangeTab={handleChangeTab}
      />
    </LayoutAdminTable>
  );
}

export default CommunicationPage;
